import ChattaCommunityTemplateScreen from '~components/new-chat/community/template/[templateId]'

export default ChattaCommunityTemplateScreen
